function randomChoice(arr) {
  return arr[Math.floor(arr.length * Math.random())];
}
function resolveVariant(options, userChoice) {
  return options.includes(userChoice) ? userChoice : randomChoice(options);
}
var variantDependencyMap = {
  navToCategory: {
    BasicTabs: ['VerticalList', 'Column', 'VerticalCardRow', 'HorizontalCardRow', 'CategoryTwoSides']
  },
  categoryToItem: {
    VerticalList: ['Basic', 'HorizontalCard', 'LeftImageHorizontalCard'],
    Column: ['Basic'],
    VerticalCardRow: ['VerticalCard'],
    HorizontalCardRow: ['HorizontalCard', 'LeftImageHorizontalCard'],
    CategoryTwoSides: ['HorizontalCard', 'LeftImageHorizontalCard']
  }
};
export function computeVariants(_ref) {
  var navDisplay = _ref.navDisplay,
    categoryDisplay = _ref.categoryDisplay,
    itemDisplay = _ref.itemDisplay,
    itemCartModal = _ref.itemCartModal;
  var navToCategory = variantDependencyMap.navToCategory,
    categoryToItem = variantDependencyMap.categoryToItem;
  var allowedCategoryVariants = navToCategory[navDisplay];
  var computedCategoryDisplay = resolveVariant(allowedCategoryVariants, categoryDisplay);
  var allowedItemVariants = categoryToItem[computedCategoryDisplay];
  var computedItemDisplay = resolveVariant(allowedItemVariants, itemDisplay);
  return {
    navDisplay: navDisplay,
    itemCartModal: itemCartModal,
    categoryDisplay: computedCategoryDisplay,
    itemDisplay: computedItemDisplay
  };
}
export function getCart(cartFromProps, cartFromContext) {
  // If cart is turned off, we don't want to use it at all
  if (cartFromProps === false) {
    return false;
  }

  // If cart is turned on and we have cart from context, use that
  if (cartFromProps === true && !!cartFromContext) {
    return cartFromContext;
  }
  return cartFromProps;
}